<template>
  <div>
    <navigation />
    <div class="users-container">
      <div class="name-popup" v-if="namePopup">
        <p>
          <span>用户名：</span>
          <input v-model="userName" />
        </p>
        <p>
          <button @click="changeUserName()">保存</button>
          <button
            @click="
              userName = '';
              userId = null;
              namePopup = false;
            "
          >
            取消
          </button>
        </p>
      </div>

      <p>
        <span>用户名/手机号：</span>
        <input v-model="keyword" @keyup.enter="getUserList()" />
        <button @click="getUserList()">搜索</button>
        <button
          @click="
            keyword = '';
            getUserList();
          "
          class="hollow-btn"
        >
          重置
        </button>
      </p>
      <div class="user-list">
        <table width="100%" class="table">
          <thead>
            <tr>
              <th>用户ID</th>
              <th>用户名</th>
              <th>手机号</th>
              <th>
                <select id="role-select" class="clickable" v-model="roleId" @change="getUserList()">
                  <option value="-1">全部角色</option>
                  <option value="0">练习生</option>
                  <option value="1">管理员</option>
                  <option value="2">客户</option>
                  <option value="3">标注员</option>
                  <option value="4">一审员</option>
                  <option value="5">二审员</option>
                  <option value="6">复审员</option>
                </select>
              </th>
              <th>切换角色</th>
              <!--              <th>-->
              <!--                <select id="status-select" class="clickable" v-model="userStatus" @change="getUserList()">-->
              <!--                  <option value="-1">全部状态</option>-->
              <!--                  <option value="0">有效</option>-->
              <!--                  <option value="1">无效</option>-->
              <!--                </select>-->
              <!--              </th>-->
              <th>操作</th>
              <th>入职成绩</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="user of userList" :key="`user${user.userId}`">
              <td>{{ user.userId }}</td>
              <td class="clickable" @click="changeNamePopup(user.userId, user.userName)">{{ user.userName }}</td>
              <td>{{ user.mobile }}</td>
              <td>{{ roleMap[user.roleId] }}</td>
              <td
                @click="
                  roleListVisible = true;
                  userId = user.userId;
                "
                :class="user.roleId > 2 || user.roleId === 0 ? 'clickable' : ''"
              >
                {{ user.roleId > 2 || user.roleId === 0 ? '切换' : '-' }}
              </td>
              <!--              <td>{{ user.userStatus ? '无效' : '有效' }}</td>-->
              <!--              <td @click="toggleStatus(user.userId)" class="clickable">切换</td>-->
              <td><el-button type="danger" size="mini" @click="toggleStatus(user.userId)">删除</el-button></td>
              <td>
                <span class="grade-info clickable" title="查看详情与管理" @click="getUserExamList(user)">
                  {{ user.grade || user.grade === 0 ? user.grade : '查看' }}
                </span>
              </td>
            </tr>
          </tbody>
        </table>
        <pagination
          :page-size="pageSize"
          :page-index="pageIndex"
          :item-total="itemTotal"
          @changeindex="changePageIndex"
          @changesize="changePageSize"
        />
      </div>
    </div>
    <el-dialog :title="`成绩管理 - ${currentUser.userName || ''}`" :visible.sync="dialogTableVisible" width="60%">
      <el-tabs v-model="activeTab">
        <el-tab-pane label="练习成绩" name="practice">
          <el-table :data="practiceList" border stripe style="width: 100%">
            <el-table-column type="index" label="序号" width="60" align="center"></el-table-column>
            <el-table-column property="name" label="练习名称" min-width="150" align="center"></el-table-column>
            <el-table-column property="finishAt" label="完成时间" width="150" align="center"></el-table-column>
            <el-table-column property="grade" label="最高分" width="100" align="center"></el-table-column>
          </el-table>
        </el-tab-pane>
        <el-tab-pane label="考试成绩" name="exam">
          <el-table :data="examRecordList" border stripe style="width: 100%">
            <el-table-column type="index" label="序号" width="60" align="center"></el-table-column>
            <el-table-column property="name" label="考试名称" min-width="150" align="center"></el-table-column>
            <el-table-column property="finishAt" label="完成时间" width="150" align="center"></el-table-column>
            <el-table-column property="grade" label="成绩" width="100" align="center"></el-table-column>
          </el-table>
        </el-tab-pane>
        <el-tab-pane label="考试可见性设置" name="visibility" v-if="currentUser.roleId === 0">
          <el-table :data="examVisibilityList" border stripe style="width: 100%" max-height="400">
            <el-table-column property="id" label="ID" width="80" align="center"></el-table-column>
            <el-table-column property="name" label="考试名称" min-width="200"></el-table-column>
            <el-table-column label="是否可见" width="120" align="center">
              <template slot-scope="scope">
                <el-switch v-model="scope.row.isVisible"></el-switch>
              </template>
            </el-table-column>
          </el-table>
          <div style="margin-top: 20px; text-align: right;">
            <el-button type="primary" size="medium" @click="saveExamVisibility">保存设置</el-button>
          </div>
        </el-tab-pane>
      </el-tabs>
    </el-dialog>
    <el-dialog title="请选择角色类别" :visible.sync="roleListVisible" width="40%" class="role-dialog">
      <el-select v-model="role" placeholder="请选择">
        <el-option v-for="item in roleOptions" :key="item.value" :label="item.label" :value="item.value"> </el-option>
      </el-select>
      <div slot="footer" class="dialog-footer">
        <el-button @click="roleListVisible = false">取 消</el-button>
        <el-button type="primary" @click="toggleRole">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import * as api from '@/api/api.js';
import pagination from '@/components/pagination';
import navigation from '@/components/navigation';
import { roleMapChinese } from '@/config';

export default {
  data: function() {
    return {
      keyword: '',
      userList: [],
      pageIndex: 0,
      pageSize: 20,
      itemTotal: 0,
      roleId: -1,
      roleMap: [],
      userId: null,
      userName: '',
      namePopup: false,
      userStatus: 0,
      userExamList: [],
      examVisibilityList: [],
      allType4Exams: [],
      dialogTableVisible: false,
      roleListVisible: false,
      role: 0,
      activeTab: 'practice',
      currentUser: {},
      roleOptions: [
        {
          value: 0,
          label: '实习生',
        },
        {
          value: 1,
          label: '管理员',
        },
        // {
        //   value: 2,
        //   label: '商户',
        // },
        {
          value: 3,
          label: '标注员',
        },
        {
          value: 4,
          label: '一审员',
        },
        {
          value: 5,
          label: '二审员',
        },
        {
          value: 6,
          label: '复审员',
        },
      ],
    };
  },
  components: {
    pagination,
    navigation,
  },

  mounted: function() {
    this.roleMap = roleMapChinese;
    this.getUserList();
    if (this.$store.state.userId !== 106) {
      this.roleOptions = this.roleOptions.filter(v => v.value != 1);
    }
  },
  computed: {
    practiceList() {
      // 过滤 type 为 3 的练习（兼容字符串类型）
      const list = this.userExamList.filter(v => parseInt(v.type) === 3);
      // 聚合最高分
      const map = {};
      list.forEach(item => {
        if (!map[item.examId] || item.grade > map[item.examId].grade) {
          map[item.examId] = item;
        }
      });
      return Object.values(map);
    },
    examRecordList() {
      // 过滤 type 为 2 或 4 的考试（兼容字符串类型）
      return this.userExamList.filter(v => parseInt(v.type) === 2 || parseInt(v.type) === 4);
    },
  },
  methods: {
    changeNamePopup(userId, userName) {
      this.userId = userId;
      this.userName = userName;
      this.namePopup = true;
    },
    changeUserName() {
      api
        .changeUserName({ userName: this.userName }, this.userId)
        .then(() => {
          this.userName = '';
          this.userId = null;
          this.namePopup = false;
          this.getUserList();
        })
        .catch(() => {});
    },
    toggleRole() {
      if (!this.userId) return;
      api
        .toggleRole(this.userId, { roleId: this.role })
        .then(() => {
          this.getUserList();
          this.roleListVisible = false;
        })
        .catch(() => {
          this.roleListVisible = false;
        });
    },
    toggleStatus(userId) {
      if (!window.confirm(`确认删除当前用户?删除后用户将从列表中移除`)) return;
      api
        .toggleStatus(userId, { status: 1 })
        .then(() => {
          this.getUserList();
        })
        .catch(() => {});
    },
    getUserList(pi = 0) {
      this.pageIndex = pi;
      let condition = { p: this.pageIndex, s: this.pageSize, r: this.roleId, stat: this.userStatus };
      if (this.keyword) condition['k'] = this.keyword;
      api
        .getUserList(condition)
        .then(res => {
          this.userList = res.data.users;
          this.itemTotal = res.data.userCount;
        })
        .catch(() => {});
    },
    changePageIndex: function(pi) {
      this.pageIndex = pi;
      this.getUserList(pi);
    },
    changePageSize: function(ps) {
      this.pageSize = parseInt(ps);
      this.getUserList();
    },
    getUserExamList(user) {
      this.currentUser = Object.assign({}, user);
      this.userExamList = []; // 先清空旧数据
      this.activeTab = 'practice'; // 默认切换到练习 Tab
      api
        .getUserExamRecords({ uid: user.userId })
        .then(res => {
          this.userExamList = res.data || [];
          this.dialogTableVisible = true;
          // 如果是实习生，获取所有 Type 4 考试以配置可见性
          if (user.roleId === 0) {
            this.fetchExamVisibility();
          }
        })
        .catch(() => {
          this.userExamList = [];
          this.dialogTableVisible = true;
        });
    },
    fetchExamVisibility() {
      api.getExamAdmin().then(res => {
        // 过滤出所有已发布的 Type 4 考试
        this.allType4Exams = res.data.filter(e => parseInt(e.type) === 4 && e.status === 2);
        const visibleIds = this.currentUser.visibleExamIds || [];
        this.examVisibilityList = this.allType4Exams.map(e => ({
          id: e.id,
          name: e.name,
          isVisible: visibleIds.includes(e.id),
        }));
      });
    },
    saveExamVisibility() {
      const visibleExamIds = this.examVisibilityList.filter(v => v.isVisible).map(v => v.id);
      api.updateUserVisibleExams(this.currentUser.userId, visibleExamIds).then(() => {
        this.$message.success('保存考试可见性设置成功');
        this.getUserList(this.pageIndex);
      });
    },
  },
};
</script>
<style scoped>
p {
  margin: 0px;
}
table {
  border-collapse: collapse;
  margin: 0px;
  text-align: left;
  font-size: 14px;
  margin-top: 18px;
}
table th,
table td {
  padding-left: 24px;
}
table thead tr {
  height: 54px;
  font-weight: 500;
  background: #fafafa;
}
table tr {
  border-bottom: 1px solid #eeeeee;
  height: 54px;
}
table tbody {
  color: #595959;
}
#role-select,
#status-select {
  border: none;
  font-size: 14px;
  font-weight: bold;
  appearance: none;
}
.name-popup {
  position: absolute;
  left: 45%;
  top: 30%;
  height: 180px;
  width: 20%;
  background: #ffffff;
  border: 1px solid #dddddd;
  border-radius: 4px;
  padding: 30px;
  box-sizing: border-box;
}
.name-popup > p {
  margin: 20px;
  text-align: center;
}
.grade-info {
  padding: 5px 10px;
  display: inline-block;
  color: #5d89c0;
  text-decoration: underline;
  cursor: pointer;
}
.grade-info:hover {
  color: #2a5a90;
}
.role-dialog >>> .el-dialog__header {
  text-align: left;
}
.role-dialog >>> .el-dialog__body {
  text-align: left;
}
</style>
